module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'form'
    ],

    config: {
        usage: 'management',
        resourceConnected: false,
        // NOTE: set these via db
        tableComponentClass: '', // e.g., templates_globals_userSessions_userSessions_table
        controllerComponentClass: '' // e.g., templates_globals_userSessions_entity_controller
    },

    model: {
        forwardFilterChanges: false,
        forceViewChange: false
    },

    events: {
        refresh: {
            type: 'click',
            selector: 'button[data-field-type="refresh"]',
            action: function(event){
                event.preventDefault();
                event.stopImmediatePropagation();

                if(event.data.component.model.entityTable){
                    event.data.component.model.entityTable.refreshData();
                }
            }
        }
    },

    methods: {
        onChange: function(isRelationChange, changeDone, fieldData){
            if(this.model.forwardFilterChanges && this.model.entityTable){
                var data = (this.model.dirtyFields || {}).data || {};
                var attributes = data.attributes || {};

                this.model.entityTable.onFilterChanged(
                    attributes,
                    isRelationChange ? !(fieldData || {}).isLastRelationElement : false,
                    isRelationChange ? (fieldData || {}).isLastRelationElement : false
                );
            }
        },
        submit: function(){}
    },

    hooks: {
        _attach: function($element, options){
            var self = this;
            if(!self.model.controller){
                self.closest(self.config.controllerComponentClass, function(controller){
                    self.model.controller = controller;
                });
            }
            if(!self.model.entityTable && self.model.controller){
                self.model.controller.find(self.config.tableComponentClass, function(table){
                    self.model.entityTable = table;
                });
            }

            this.model.forwardFilterChanges = true;
            if(this.config.usage === 'selection' || Object.keys(((this.model.dirtyFields || {}).data || {}).attributes || {}).length > 0){
                this.model.forceViewChange = true;
                this.onChange();
                this.model.forceViewChange = false;
            }
        }
    }
}